import headerCart from './HeaderCart';
import headerNotifications from './HeaderNotifications';
import { getSearchUrl } from './HeaderSearch';
import headerSSO from './HeaderSSO';
export const headerActions = (rootStore) => {
    var _a;
    const cart = headerCart(rootStore);
    const menu = headerMenu(rootStore.translationsStore);
    const sso = headerSSO(rootStore);
    const notifications = headerNotifications(rootStore);
    const search = headerSearch(rootStore);
    const items = [search, notifications, cart, sso, menu];
    return {
        items: items.filter((item) => !!item),
        sso: {
            isSsoLoaded: rootStore.ssoStore.isInitialized,
            isLoggedIn: (_a = rootStore.ssoStore.authData) === null || _a === void 0 ? void 0 : _a.isLoggedIn
        }
    };
};
const headerMenu = (translationsStore) => {
    if (!translationsStore.translations) {
        return undefined;
    }
    return {
        id: 'nav',
        url: '#',
        label: translationsStore.translate('header.menu'),
        location: 'bottom',
        icon: '#menu-burger'
    };
};
const headerSearch = (rootStore) => {
    const { URLData } = rootStore.environmentStore;
    const { translate } = rootStore.translationsStore;
    const { segment } = rootStore.locationStore;
    const { customerType } = rootStore.ssoStore.authData;
    return {
        id: 'search',
        icon: '#search',
        url: URLData.getPublicLink(getSearchUrl(segment, customerType)),
        label: translate('header.actions.search.openLabel'),
        closeLabel: translate('header.actions.search.closeLabel'),
        location: 'bottom',
        showOverlay: false
    };
};
export default headerActions;
//# sourceMappingURL=HeaderActions.js.map